import { render } from "./OrderCreateSustainabilityWithProduct.vue?vue&type=template&id=2811bce0"
import script from "./OrderCreateSustainabilityWithProduct.vue?vue&type=script&lang=js"
export * from "./OrderCreateSustainabilityWithProduct.vue?vue&type=script&lang=js"

import "./OrderCreateSustainabilityWithProduct.vue?vue&type=style&index=0&id=2811bce0&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__